import { Injectable } from '@angular/core';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ScreenOrientationService {
	public isOrientationLandscape$: Observable<boolean>;
	private isOrientationLandscapeSubject: BehaviorSubject<boolean>;

	public constructor(private screenOrientation: ScreenOrientation) {
		this.isOrientationLandscapeSubject = new BehaviorSubject(this.isOrientationLandscape);
		this.isOrientationLandscape$ = this.isOrientationLandscapeSubject.asObservable();

		this.screenOrientation
			.onChange()
			.subscribe(() => this.isOrientationLandscapeSubject.next(this.isOrientationLandscape));
	}

	private get isOrientationLandscape(): boolean {
		return (
			this.screenOrientation.type === this.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
			this.screenOrientation.type === this.screenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY
		);
	}
}
